import { useTranslation } from "react-i18next";

import { Notice } from "@/components";
import { Button } from "@/components/ui/button";

export const CONNECT_ERROR_REASONS = [
  "cancelled",
  "expired",
  "unavailable",
  "failed",
] as const;

export type ConnectErrorReason = (typeof CONNECT_ERROR_REASONS)[number];

const MESSAGE = {
  cancelled: "The connection was cancelled before it finished.",
  expired: "This link has expired. Links are good for 10 minutes.",
  unavailable: "The connection is not available right now.",
  failed: "John Deere could not complete the connection.",
} as const satisfies Record<ConnectErrorReason, string>;

type Props = {
  reason: ConnectErrorReason;
  retryHref: string | null;
};

export function ConnectErrorView({ reason, retryHref }: Props) {
  const { t } = useTranslation();

  return (
    <main className="mx-auto grid max-w-md gap-6 p-6">
      <h1 className="font-heading font-bold text-2xl uppercase leading-tight tracking-[0.01em]">
        {t("We could not connect your account")}
      </h1>

      <Notice tone="warning" toneLabel={t("Warning")}>
        {t(MESSAGE[reason])}
      </Notice>

      {retryHref ? (
        <Button asChild size="lg">
          <a href={retryHref}>{t("Try again")}</a>
        </Button>
      ) : (
        <p className="text-muted-foreground text-sm">
          {t("Ask your support contact for a new link and open it again.")}
        </p>
      )}
    </main>
  );
}
